const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/floatWindowContent.vue3.js
// module id = 1249
// module chunks = 41